import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import LinkifyWrapper from '../LinkifyWrapper';

const LinkListDescription = ({ value, className }) => (
  <List.Description className={clsx('aridhia-link-list-description', className)}>
    <LinkifyWrapper>
      {value}
    </LinkifyWrapper>
  </List.Description>
);

export default LinkListDescription;
